import React, { useEffect, useState } from 'react';
import API from '../services/api';
import AptitudeAnalytics from '../components/aptitude/AptitudeAnalytics';
import './StudentPages.css';

// Student portal → Aptitude Analytics.
// Continuous-performance module sourced ONLY from Aptitude Tests
// (aptitude_profile + aptitude_attempt_scores). Diagnostic/Mock data excluded.
// All analytics come from stored per-attempt metrics — never recalculated.
const StudentAnalytics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/portal/dashboard')
      .then(res => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="s-loading">Loading analytics…</div>;

  const aptitude = data?.aptitude || {};

  return (
    <div className="analytics-page-content">
      <AptitudeAnalytics
        profile={aptitude.profile || null}
        history={aptitude.history || []}
        trend={aptitude.trend || []}
        subtitle="Your continuous aptitude performance — growth across every test you take."
      />
    </div>
  );
};

export default StudentAnalytics;
